import { plural } from '@cian/utils';
import * as style from './style.css';
import { IUnderground } from '../../../../types/layouts/underground';
import { UndergroundIcon } from '../UndergroundIcon';
import { Responsive, UIText2 } from '@cian/ui-kit';
import { useMemo } from 'react';
import type * as React from 'react';
import { IconMapBus16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';

const DOT = '・';

export const Underground = ({ iconType, lineColor, name, transportType, time }: IUnderground): React.JSX.Element => {
  const remoteness = useMemo(() => {
    const unit = plural(time, ['минута', 'минуты', 'минут']);
    const transport = transportType === 'walk' ? 'пешком' : 'на транспорте';

    return `${time} ${unit} ${transport}`;
  }, []);

  const Icon = useMemo(() => {
    return transportType === 'walk' ? IconMapWalk16 : IconMapBus16;
  }, [transportType]);

  return (
    <div className={style['container']}>
      <UndergroundIcon type={iconType} color={lineColor} />
      <UIText2>{name}</UIText2>
      <Responsive desktop>
        {DOT}
        <UIText2 color="gray60_100">{remoteness}</UIText2>
      </Responsive>

      <Responsive phone tablet>
        <div className={style['mobile-remoteness']}>
          <Icon />
          <UIText2 color="gray60_100">{time} мин</UIText2>
        </div>
      </Responsive>
    </div>
  );
};
